// extracted by mini-css-extract-plugin
export var childrenContainer = "_3l-0";
export var virtualScrollArea = "_3l-1";